<template>
    <div>
        <!-- Display a payment form -->
        <form id="payment-form" style="min-height: 200px">
            <div id="payment-element">
                <!-- Elements will create form elements here -->
            </div>
            <div id="error-message">
                <!-- Display error message to your customers here -->
            </div>
            <div
                class="flex justify-center align-center"
                style="height: 200px"
                v-if="elementsLoading"
            >
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </div>
        </form>
    </div>
</template>

<script>
import FormItem from "./Form/FormItem.vue";

export default {
    components: {
        FormItem,
    },
    props: {
        errors: {},
    },
    data() {
        return {
            elementsLoading: false,
            stripe: null,
            stripeElements: null,
        };
    },
    methods: {
        async manualCardElement() {
            this.elementsLoading = true;

            /*const stripeLoaded = document.querySelectorAll(
                "script[src='https://js.stripe.com/v3/']"
            ).length;

            if (!stripeLoaded) {
                await this.$loadScript("https://js.stripe.com/v3/");
            }*/

            await this.$loadScript("https://js.stripe.com/v3/");

            const response = axios
                .get(route("stripe.webIntent"))
                .then((resp) => {
                    const clientSecret = resp.data.client_secret;
                    this.stripe = Stripe(resp.data.stripe_key);
                    const appearance = {
                        theme: "stripe",
                        labels: "floating",
                        variables: {
                            colorText: "#4b6876",
                            spacingUnit: "2px",
                            borderRadius: "20px",
                            spacingTab: "16px",
                            spacingGridRow: "20px",
                            spacingGridColumn: "16px",
                        },
                    };
                    const elements = this.stripe.elements({
                        clientSecret,
                        appearance,
                        loader: "always",
                    });
                    this.stripeElements = elements;

                    const paymentElement = elements.create("payment", {
                        wallets: { applePay: "never", googlePay: "never" },
                        terms: { card: "auto" },
                    });

                    paymentElement.mount("#payment-element");
                    paymentElement.on("loaderstart", (event) => {
                        this.elementsLoading = false;
                    });
                    this.$emit("stripeLoaded");
                });
        },
    },
    created() {
        this.manualCardElement();
    },
};
</script>
